import { render, staticRenderFns } from "./AgreementLayoutComponent.vue?vue&type=template&id=3b5f4a2b&"
import script from "./AgreementLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./AgreementLayoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgreementLayoutComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports